import { render, staticRenderFns } from "./FormDate.vue?vue&type=template&id=02c6ed54&scoped=true&"
import script from "./FormDate.vue?vue&type=script&lang=tsx&"
export * from "./FormDate.vue?vue&type=script&lang=tsx&"
import style0 from "./FormDate.vue?vue&type=style&index=0&id=02c6ed54&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c6ed54",
  null
  
)

export default component.exports